var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.INVOICE_STATUS = {
    SEND_TO_INSURER: 'SEND_TO_INSURER',
    WAITING_FOR_ACCEPTATION: 'WAITING_FOR_ACCEPTATION'
};

Object.freeze(Enum.MEEDY.INVOICE_STATUS);